import { Injectable } from "@angular/core";
import { User } from "../models/auth/user";
import { AuthService } from "./auth.service";

@Injectable({
    providedIn: "root",
})
export class AuthGuardService {
    user: User;
    constructor(private authService: AuthService) {}

    isRouteAllowed = async (url: string): Promise<boolean> => {
        return this.authService.isLoggedIn;
    };
}
